import React from 'react';
import { ObservableField as Field, useForm } from '../../ObservableForm';
import { MultiSelectChoiceFieldFragment } from './MultiSelectChoiceField.generated';
import { MultiSelectField } from '@99designs/spa-common';
import styled from 'styled-components';

export type Props = MultiSelectChoiceFieldFragment;

// TODO: Swap this to use 99designs UI combobox MultiSelect.tsx after replacing ObservableForm
export function Edit({ id: name, label, required, options }: Props) {
    const form = useForm();

    return (
        <Field
            form={form}
            name={name}
            title={label}
            required={required ?? false}
            render={() => (
                <MultiSelectField
                    value={form.get(name) ?? []}
                    options={options}
                    onChange={(values) => form.set(name, values)}
                />
            )}
        />
    );
}

const List = styled.ul`
    margin-bottom: 0;
`;

export function View({ multiChoiceValues: values, options }: Props) {
    return (
        <List>
            {options
                .filter((o) => values.includes(o.value))
                .map((o) => (
                    <li key={o.value}>{o.label}</li>
                ))}
        </List>
    );
}

export function HasValue({ multiChoiceValues }: Props): boolean {
    return multiChoiceValues.length !== 0;
}

export function getValue({ multiChoiceValues }: Props) {
    return multiChoiceValues;
}
